/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MachineUsageV2 } from '../../models/machine-usage-v-2';

export interface ApiV0MachineUsageCompanyCompanyIdGet$Json$Params {
  companyId: string;
}

export function apiV0MachineUsageCompanyCompanyIdGet$Json(http: HttpClient, rootUrl: string, params: ApiV0MachineUsageCompanyCompanyIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MachineUsageV2>>> {
  const rb = new RequestBuilder(rootUrl, apiV0MachineUsageCompanyCompanyIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MachineUsageV2>>;
    })
  );
}

apiV0MachineUsageCompanyCompanyIdGet$Json.PATH = '/api/v0/machine-usage/company/{companyId}';
